import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import AnimationLoading from './animationLoading';

const SimpleButton = styled.button.attrs(props => ({
  type: props.type ? props.type : 'button',
}))`
  width: 100%;
  height: 30px;
  border: none;
  padding: 0 10px;
  border-radius: 500px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => (props.bg ? props.bg : '#fff')};
  color: ${props => (props.color ? props.color : '#333')};

  cursor: ${props => {
    if (props.disabled) {
      return 'not-allowed';
    }
    if (props.loading) {
      return 'progress';
    }
    return 'pointer';
  }};
  :active {
    opacity: 0.5;
  }
`;

const ButtonContainer = styled.div`
  padding: 5px;
`;

function Button({ text, loading, Icon, ...props }) {
  return (
    <ButtonContainer>
      <SimpleButton loading={loading} {...props}>
        {loading ? (
          <AnimationLoading />
        ) : (
          <>
            <Icon size={15} /> {text}
          </>
        )}
      </SimpleButton>
    </ButtonContainer>
  );
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  Icon: PropTypes.elementType.isRequired,
};

Button.defaultProps = {
  loading: false,
};

export default Button;
